"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeRange = void 0;
var IncomeRange;
(function (IncomeRange) {
    IncomeRange[IncomeRange["LessThan18KEur"] = 0] = "LessThan18KEur";
    IncomeRange[IncomeRange["From18To30KEur"] = 1] = "From18To30KEur";
    IncomeRange[IncomeRange["From30To50KEur"] = 2] = "From30To50KEur";
    IncomeRange[IncomeRange["From50To80KEur"] = 3] = "From50To80KEur";
    IncomeRange[IncomeRange["From80To120KEur"] = 4] = "From80To120KEur";
    IncomeRange[IncomeRange["MoreThan120KEur"] = 5] = "MoreThan120KEur";
})(IncomeRange || (exports.IncomeRange = IncomeRange = {}));
//# sourceMappingURL=IncomeRange.js.map